import React, { useMemo } from 'react';
import { Flex, Image, Select } from "antd";
import { AssetDto } from "./data/types";
import { useQuery } from "react-query";
import axios, { AxiosResponse } from "axios";
import { useTranslation } from "react-i18next";

export const GeneralImageChooser: React.FC<{ value?: any, onChange?: (value: any) => void }> = ({ value, onChange }) => {
    const { t } = useTranslation();

    const { data: allAssets } = useQuery(
        'general-assets-images',
        () => axios.get<object, AxiosResponse<AssetDto[]>>(`/api/assets/images`)
            .then(r => r.data)
    );

    const assets = useMemo<AssetDto[]>(() => allAssets || [], [allAssets]);

    return (
        <Select
            value={value}
            onChange={onChange}
            showSearch
            placeholder={t('organizer.adventures.form.cover.placeholder')}
            filterOption={(input, option) =>
                ((option?.label) as string ?? '').toLowerCase().includes(input.toLowerCase())
            }
        >
            {assets.map(asset => (
                <Select.Option key={asset.id} value={asset.id} label={asset.name}>
                    <Flex align="center" justify="space-between">
                        <Flex justify="center" vertical={true}>
                            <Image src={asset.url} height={24} width={24} preview={false} style={
                                { marginRight: 10, marginBottom: '10px', borderRadius: 4, objectFit: 'cover' }} />
                        </Flex>
                        <div>{asset.name}</div>
                    </Flex>
                </Select.Option>
            ))}
        </Select>
    );
}
